/*  eslint-disable camelcase */
import { fetchCommentsRequest } from 'actions/envelopeActions';
import type { EnvelopeAction, Selector } from 'types';

export const getFetchCommentsLoading: Selector<boolean> = (state) =>
  state.envelopeActions.loading.includes(fetchCommentsRequest.toString());

export const getActions: Selector<EnvelopeAction[]> = (state) =>
  Object.values(state.envelopeActions.items);

export const getActionsCount: Selector<number> = (state) => state.envelopeActions.count;
